import _, { isEmpty, trim } from 'lodash';

// handleFieldError field
export const handleFieldError = (value, setting, uploaded = false, form = {}) => {
  let error = {};
  let isValid = true;
  if (setting) {
    if (setting.required && ((setting.type === 'checkboxGroup' && !value.some(a => a.checked)) || value === null || value === undefined || isEmpty(trim(value.toString())))) {
      error.required = true;
      isValid = false;
    }
    if (!isEmpty(value)) {
      if (setting.min !== undefined && !(parseFloat(setting.min) <= parseFloat(value))) {
        error.min = true;
        isValid = false;
      } else if (setting.max && !(parseFloat(setting.max) >= parseFloat(value))) {
        error.max = true;
        isValid = false;
      } else if (setting.minLength && value.toString().length < setting.minLength) {
        error.minLength = true;
        isValid = false;
      } else if (setting.maxLength && value.toString().length > setting.maxLength) {
        error.maxLength = true;
        isValid = false;
      } else if (setting.anySpaceNotAllowed && value.match(/[\s]/g)) {
        error.space = true;
        isValid = false;
      } else if (setting.pattern && !setting.pattern.test(value)) {
        error.pattern = true;
        isValid = false;
      } else if (setting.upto3Digit && (isNaN(value) || checkDecimal(value, 3))) {
        error.upto3Digit = true;
        isValid = false;
      }
      else if (setting.upto2Digit && (isNaN(value) || checkDecimal(value, 2))) {
        error.upto2Digit = true;
        isValid = false;
      }
      else if (setting.upto4Digit && (isNaN(value) || checkDecimal(value, 4))) {
        error.upto4Digit = true;
        isValid = false;
      }
      else if (setting.decimalOnly && (isNaN(value) || checkDecimal(value, 0))) {
        error.decimalOnly = true;
        isValid = false;
      } else if (setting.zeroNotAllowed && (isNaN(value) || value == 0)) {
        error.zeroNotAllowed = true;
        isValid = false;
      } else if (setting.uploadRequired && !uploaded) {
        error.uploadRequired = true;
        isValid = false;
      } else if (setting.spaceNotAllowed && value.match(/^\s+|\s+$/g)) {
        error.space = true;
        isValid = false;
      }
      else if (setting.customError) {
        error.customError = true;
        isValid = false;
      }
      else if (setting.ioBudgetNullError) {
        error.ioBudgetNullError = true;
        isValid = false;
      }

    } else if (setting.uploadRequired && !uploaded) {
      error.uploadRequired = true;
      isValid = false;
    } else if (setting.upto3Digit && (isNaN(value) || checkDecimal(value, 3))) {
      error.upto3Digit = true;
      isValid = false;
    }
    else if (setting.upto2Digit && (isNaN(value) || checkDecimal(value, 2))) {
      error.upto2Digit = true;
      isValid = false;
    }
    else if (setting.decimalOnly && (isNaN(value) || checkDecimal(value, 0))) {
      error.decimalOnly = true;
      isValid = false;
    } else if (setting.zeroNotAllowed && (isNaN(value) || value == 0)) {
      error.zeroNotAllowed = true;
      isValid = false;
    }
  }
  return { error, isValid };
};

export const checkDecimal = (value, decimal) => {
  if (value.toString().indexOf('.') > -1 && (value.toString().substr(value.toString().indexOf('.') + 1).length > decimal)) {
    return true;
  }
  return false;
};

// intialize form
export const initializeForm = (formFields) => {
  let form = {};
  let errors = {};
  _.each(_.keys(formFields), function (key) {
    form[key] = formFields[key] ? formFields[key].defaultValue || '' : '';
    errors[key] = {};
  });
  return { form, errors };
};


//common handleError
export const handleError = (value, formFields) => {
  let errors = {};
  let valid = true;
  _.each(_.keys(formFields), (key) => {
    let { error, isValid } = handleFieldError(value[key], formFields[key], value[key + '-uploaded']);
    if (!isValid) valid = isValid;
    errors[key] = error;
  });
  return { errors, valid };
};